import Artist from './ArtistContainer';

export default Artist;
